exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.el-table__body[data-v-2046c57d] {\n  width: 100%;\n  table-layout: fixed !important;\n}\n", ""]);

// exports
